import { render } from "./FacebookSignIn.vue?vue&type=template&id=84dc7b1a"
import script from "./FacebookSignIn.vue?vue&type=script&lang=js"
export * from "./FacebookSignIn.vue?vue&type=script&lang=js"

import "./FacebookSignIn.vue?vue&type=style&index=0&id=84dc7b1a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__